import React from "react";
import { Controller } from "react-hook-form";
import { PatternFormat } from "react-number-format";

const MaskInput = ({
	label,
	name,
	control,
	errors,
	placeholder,
	onKeyDown,
	autoFocus = false,
	className,
	format,
	required = false, // Adicione uma prop para required
	// inputRef = null, // Add default value for inputRef
}) => {
	return (
		<div className={`input-box ${className}`}>
			<label htmlFor={name}>{label}</label>
			<Controller
				name={name}
				control={control}
				// rules={{
				// 	required: required ? "Este campo é obrigatório" : false,
				// }}
				render={({ field: { onChange, onBlur, value, ref } }) => (
					<PatternFormat
						value={value || ""} // Valor padrão para vazio
						onValueChange={(values) => {
							onChange(values.formattedValue);
						}}
						format={format}
						id={name}
						className={errors?.[name] ? "error" : ""}
						placeholder={placeholder}
						onBlur={onBlur}
						onKeyDown={onKeyDown}
						autoFocus={autoFocus}
						required={required}
						autoComplete="off"
						// ref={inputRef} // Add ref here

						// customInput={Input}
					/>
				)}
			/>
			{errors?.[name] && <p className="errors">{errors[name].message}</p>}
		</div>
	);
};

// const Input = ({ ...props }) => <input {...props} />;

export default MaskInput;

//values.formattedValue  = valor com a mascara
//values.value = valor sem a mascara
